import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {CVA} from "./cva";
import {UIFormEngineComponentMetadata} from "./form";


@Component({
    selector: 'ui-input-checkbox',
    template: `
	    <label class=" form-control">

		    <div class="form-check-inline">
			    <div class="form-check-label ">
				    {{name}}
				    <input
					    type="checkbox"
					    class="form-check-input"
					    [(ngModel)]="cva.value"
					    [checked]="cva.value"
					    (ngModelChange)="writeValueFromInput($event)"
					    [name]="name"
				    />
				    <span class="ui-input-choices-label">{{metadata?.options?.placeholder ? metadata?.options?.placeholder : metadata?.label}}</span>
			    </div>
		    </div>
	    </label>
    `,
    host: {class: 'ui-input-checkboxes'}, // this is not a typo, we use the ui-input-checkboxes as it is basically the same component css wise
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => UIInputCheckboxComponent),
            multi: true
        }
    ]
})
export class UIInputCheckboxComponent extends CVA {
    @Input() metadata: UIFormEngineComponentMetadata;
    @Input() name;
    @Input() presentationMode = false;

    writeValueFromInput(obj) {
        console.log('cjheck',obj);
        this.cva.value = obj;
        this.cva.onChangeFunction(obj);
        this.cva.onTouchedFunction(obj);
    }
}
